module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "width": "64",
      "height": "64",
      "src": _vm.seller.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "brand"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.seller.name))])]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.seller.description) + "·约" + _vm._s(_vm.seller.deliveryTime) + "分钟送达\n      ")]), _vm._v(" "), (_vm.seller.supports) ? _c('div', {
    staticClass: "support"
  }, [_c('span', {
    staticClass: "icon",
    class: _vm.classMap[_vm.seller.supports[0].type]
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.seller.supports[0].description))])]) : _vm._e()]), _vm._v(" "), (_vm.seller.supports) ? _c('div', {
    staticClass: "support-count",
    on: {
      "click": _vm.showDetail
    }
  }, [_c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.seller.supports.length) + "个")]), _c('span', {
    staticClass: "icon-font icon-keyboard_arrow_right"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulletin-wrapper",
    on: {
      "click": _vm.showDetail
    }
  }, [_c('span', {
    staticClass: "bulletin-title"
  }), _c('span', {
    staticClass: "bulletin-text"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))]), _vm._v(" "), _c('i', {
    staticClass: "icon-font icon-keyboard_arrow_right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "background"
  }, [_c('img', {
    attrs: {
      "src": _vm.seller.avatar,
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailShow),
      expression: "detailShow"
    }],
    staticClass: "detail",
    attrs: {
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "detail-wrapper clearfix"
  }, [_c('div', {
    staticClass: "detail-main"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "star-wrapper"
  }, [_c('star', {
    attrs: {
      "size": 48,
      "score": _vm.seller.score
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("优惠信息")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), (_vm.seller.supports) ? _c('ul', {
    staticClass: "supports"
  }, _vm._l((_vm.seller.supports), function(item, index) {
    return _c('li', {
      staticClass: "supports-item"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.classMap[_vm.seller.supports[index].type]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.seller.supports[index].description))])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("商家公告")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bulletin"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-close"
  }, [_c('i', {
    staticClass: "icon-close",
    on: {
      "click": _vm.hideDetail
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b52249d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 50
// module chunks = 0